import { useContext } from "react";
import { useQuery } from "react-query";
import { PensionProgressSaverContext } from "../../components/pension-robot/cocktail-filler-screen/DialogueDataSaving/PensionProgressSaverContext";
import { RobotEnvironmentContext } from "../../contexts/general/RobotEnvironmentContext";
import { buildEndpoint } from "../endpoints";
import { defaultHeaders } from "../robotapi";

const deletePensionDialogueDataUrl = (userId: string) => 
    buildEndpoint(['pensiondata', 'client', userId]);

export const useDeletePensionDialogueData = () => {
    const { userToken } = useContext(RobotEnvironmentContext);
    const {
        pensionProgressSaverData,
        setPensionProgressSaverData
    } = useContext(PensionProgressSaverContext);

    const onSuccess = () => {
        !!setPensionProgressSaverData && setPensionProgressSaverData({
            ...pensionProgressSaverData,
            dataIsSavedAtLeastOnce: false
        });
    };

    const query = useQuery(
        ['pensiondelete', userToken],
        async () => {
            const request: RequestInit = {
                method: "DELETE",
                headers: defaultHeaders,
            };
            if (userToken === undefined)
                return undefined
            return fetch(deletePensionDialogueDataUrl(userToken), request);
    },
    {
        enabled: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        onSuccess
    });
    return query;
};